<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="intro_box cont840">
      <div class="title_2">关于HOC TIME</div>
      <hr class="hr_1" />
      <img src="static/picture/HT/HT1.jpg" />
      <p class="mt20">HOC TIME</p>
      <p class="mt20">为敏感而生</p>
      <p class="mt20">沿传纯净护肤的品牌初心，遵从“安心、安全、有效”的产品研发理念，为敏感肌提供“还原肌肤原生态”的解决方案，打造适应环境变化、简约高效的护肤体验</p>
      <hr class="hr_1 mt40" />
      <dl class="dl_basic">
        <dt>
          <img src="static/picture/HT/6K7A8140-2(1).jpg" />
        </dt>
        <dd>
          <h1>基本信息</h1>
          <p class="mt20">
            品牌名称：HOC TIME
            <br />
            <br />日文名称： ホックタイム
            <br />
            <br />所属行业：护肤
            <br />
            <br />国&nbsp;&nbsp;&nbsp;&nbsp;家：日本
            <br />
            <br />日本官网：
            <a class="a_link" href="https://luara.co.jp/">https://luara.co.jp/</a>
            <br />
            <br />&nbsp;
          </p>
        </dd>
      </dl>
      <!-- <hr class="hr_1 mt40" />
      <h1>品牌故事</h1>
      <h1 class="mt20">RELEASE THE ZERO MOMENT OF SKIN</h1>
      <p class="mt20">
        释放肌肤0时刻
        <br />
        <br />HOC TIME坚持“0”美学追求，为都市快节奏人群，提供轻负担、精简高效的护肤解决方案。
        <br />呵护城市肌肤，绽放肌肤原生态的美。
      </p>-->
      <hr class="hr_1 mt40" />
      <h1>品牌介绍</h1>
      <p class="mt20">
        HOC TIME诞生于日本，始于“为敏感而生”的品牌理念，持续专研敏感肌的肌肤问题，提供敏感肌修护方案，提倡“极简护肤”的护 肤理念。
        <br />
        <br />2017年创建之初，HOC TIME主要针对“极简护肤”的市场需求，打造出一系列适合亚洲都市女性的“精简”“高效”的产品。
        <br />
        <br />2020年，重塑品牌，以“为敏感而生”的品牌理念诞生，HOC TIME进入品牌升级期。自此HOC TIME坚持采用大自然温和、精简的植萃配方，为敏感肌提供“还原肌肤原生态”的解决方案，释放肌肤 “0”时刻，打造适应环境变化、简约高效的护肤体验。
      </p>
      <!--<hr class="hr_1 mt40" />
    <h1>品牌传承</h1>
      <p
        class="mt20"
      >日本香椎化学工业株式会社成立于1952年，70余年来，以“培育美丽肌肤”为初心，坚持“安心、安全、有效”的产品研发理念，专研大自然温和、精简的植萃配方，赋注创新美容科技，呵护都市女性的敏感肌肤。</p>
      <p class="mt20">HOC TIME延传香椎的研发理念，为敏感肌肤提供“还原肌肤原生态”的解决方案，释放肌肤“0”时刻，打造适应环境变化、简约高效的护肤体验。</p>-->
      <hr class="hr_1 mt40" />
      <h1>研发理念</h1>
      <p class="mt20">HOC TIME由日本香椎化学工业株式会社潜心研发。</p>
      <p class="mt20">
        日本香椎化学工业株式会社于1952年成立，以“培育美丽肌肤”为目标，以“安心、安全、有效”的理念为核心，以皮肤学理论、利用肌肤原生力量为基础，专研大自然温和、 精简的植萃配方，赋注创新美容科技，呵护都市女性的敏感肌肤。
        <br />
        <br />70多年来，香椎不停研发新技术，并应用于化妆品的企划、研发、制造中。由香椎研发生产的产品，不是机械化的生产，每一款产品都是在有温度的双手精心打造下诞生的。
      </p>
      <!-- <hr class="hr_1 mt40" />
      <h1>发展历程</h1>
      <p
        class="mt20"
      >2017年，香港之然化妆品有限公司委托LEWA株式会社，与日本香椎化学工业株式会社就针对“极简护肤”的诉求研发出一套适合亚洲都市女性的“精简”“高效”的产品，创立HOC TIME，并推出五款产品，产品包含：二合一卸妆凝胶、六合一面霜、三合一眼霜、面膜、颈霜。</p>
      <p
        class="mt20"
      >2020年，LEWA株式会社拿下HOC TIME品牌的经销权及运营权，根据市场变化、消费需求、销售反馈，HOC TIME进入品牌升级期，由香椎化学工业株式会社全面专研提升产品品质。</p>
      <p
        class="mt20"
      >2021年，历时两年，完成品牌战略、产品设计、生产技术等多个方面的全方位升级后，HOC TIME品牌重新回归市场，并推出五款第二代产品，产品包含：卸妆凝胶、保湿凝胶霜、浓缩精粹眼霜、颈霜、面膜。</p>
      <p class="mt20">2022年，推出五款产品，产品包含：化妆水、乳液、美容液、面霜、洁面乳。</p>-->
      <hr class="hr_1 mt40" />
      <h1>品牌历程</h1>
      <p class="mt20">针对“极简护肤”的消费需求，日本香椎化学工业株式会社研发出一套适合亚洲都市女性的“精简”“高效”的产 品，2017年HOC TIME诞生。</p>
      <p
        class="mt20"
      >2020年，LEWA株式会社结合市场变化、消费需求、销售反馈开始全权负责HOC TIME的品牌建设及市场运营， 同时委托香椎化学工业株式会社全面把控产品，专研提升产品品质。HOC TIME进入品牌升级期。</p>
      <p class="mt20">2021年，历时两年，HOC TIME完成品牌战略、产品设计、生产技术等多个方面的全方位升级，第二代HOC TIME以全新的品牌形象亮相。</p>
      <hr class="hr_1 mt40" />
      <h1>产品历程</h1>
      <p class="mt20">2017年，HOC TIME推出“多效合一”“懒人式护肤”系列产品，共五款产品包含：二合一卸妆凝胶、六合一面霜、三合一眼霜、面膜、颈霜。</p>
      <p class="mt20">2020年，HOC TIME进行产品升级。</p>
      <p class="mt20">2021年12月，HOC TIME推出以“为敏感而生”为理念的第二代产品，产品包含：卸妆凝胶、保湿凝胶霜、浓缩精粹眼霜、颈霜、面膜。</p>
      <p class="mt20">2022年2月，推出同系列五款产品，产品包含：化妆水、乳液、美容液、面霜、洁面乳。</p>
      <hr class="hr_1 mt40" />
      <h1>社会责任</h1>
      <p class="mt20">HOC TIME关注社会的可持续发展，注重与环境的亲密关系。珍惜自然馈赠，倡导消费者开始有智慧地减少使用 地球上的资源。</p>
      <p class="mt20">HOC TIME关注社会的可持续发展，注重与环境的亲密关系。珍惜自然馈赠，倡导消费者开始有智慧地减少使用 地球上的资源。</p>
      <p class="mt20">留存一片净土，对环境保护持有善意之心，让个人与环境的美好循循而至。</p>
      <hr class="hr_1 mt40" />
      <dl>
        <dt>
          <img src="static/picture/HT/44332211.jpg" />
        </dt>
        <dd>
          <h1>明星产品</h1>
          <h2 class="mt30">卸妆凝胶</h2>
          <p>四合一补水式卸妆 一键净澈毛孔</p>
        </dd>
      </dl>
      <dl class="mt40">
        <dt>
          <img src="static/picture/HT/NEW_7928X(1).jpg" />
        </dt>
        <dd>
          <h1>明星产品</h1>
          <h2 class="mt30">保湿凝胶霜</h2>
          <p>六合一懒人凝霜多效合一 唤醒肌肤活力</p>
        </dd>
      </dl>
      <dl class="mt40">
        <dt>
          <img src="static/picture/HT/1.png" />
        </dt>
        <dd>
          <h1>明星产品</h1>
          <h2 class="mt30">化妆水</h2>
          <p>小分子润活 唤醒质感美肌</p>
        </dd>
      </dl>
      <dl class="mt40">
        <dt>
          <img src="static/picture/HT/2.png" />
        </dt>
        <dd>
          <h1>明星产品</h1>
          <h2 class="mt30">颈霜</h2>
          <p>弹润轻龄 打造芭蕾颈</p>
        </dd>
      </dl>
      <hr class="hr_1 mt40" />
    </div>
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>
  
  <script>
import HeaderNav from "../../components/HeaderNav";
import FooterNav from "../../components/FooterNav";
import Banner from "../../components/Banner.vue";
import RightNav from "../../components/RightNav.vue";
import { apiGetDetail, apiChangeOther, apiAddNotes } from "../../api/job.js";
export default {
  name: "Index",
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: "../../static/pC/ad.png" },
      id: "",
      login: false, //是否登录
      userInfo: [], //是否登录--用户信息
      bannerList: [
        { url: "static/picture/luara_banner1.jpg" },
        { url: "static/picture/luara_banner2.jpg" },
        { url: "static/picture/luara_banner3.jpg" }
      ]
    };
  },
  created() {},
  methods: {
    //跳转到外部链接
    linkOut(url) {
      if (url.includes("https://") || url.includes("http://")) {
        window.location.href = url;
      } else {
        window.location.href = `https://${url}`;
      }
    },

    //判断是否登录
    judgeLogin() {
      if (
        sessionStorage.getItem("login") != null &&
        sessionStorage.getItem("login") != ""
      ) {
        this.login = sessionStorage.getItem("login");
        if (
          sessionStorage.getItem("userInfo") != null &&
          sessionStorage.getItem("userInfo") != ""
        ) {
          var userInfo = sessionStorage.getItem("userInfo");
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
  <style scoped>
@media (min-width: 1110px) {
  .cont840 {
    width: 840px;
    margin: 0 auto;
  }
}
@media (min-width: 768px) {
  .nav li {
    padding: 0 15px;
  }
  .pc_img {
    display: none;
  }
  .wap_img {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: block;
  }
}

@media (min-width: 1110px) {
  .pc_img {
    display: block;
  }
  .wap_img {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: none;
  }
}
/*------------about_intro.html  start----------------*/
.intro_box {
  overflow: hidden;
  padding: 40px 0 60px;
}
.intro_box img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
.intro_box h1 {
  color: #2e2e2e;
  font-size: 18px;
  font-family: Font_Medium;
}
.intro_box p {
  color: #2e2e2e;
  line-height: 26px;
  margin: 0;
  font-size: 15px;
  font-family: Font_Light;
}
.intro_box dl {
  width: 100%;
  overflow: hidden;
}
.intro_box dl dt {
  float: left;
  width: 245px;
}
.intro_box dl.dl_basic dt {
  width: 560px;
}
.intro_box dl.dl_100 dt {
  float: inherit;
  width: 100%;
}
.intro_box dl dt img {
  max-width: 100%;
}

.intro_box dl dd {
  float: right;
  width: calc(100% - 270px);
  color: #2e2e2e;
}
.intro_box dl.dl_basic dd {
  width: calc(100% - 580px);
}
.intro_box dl.dl_100 dd {
  float: inherit;
  width: 100%;
}
.intro_box dl dd h2 {
  margin-top: 0;
  font-size: 15px;
  font-family: Font_Medium;
}
.intro_box dl dd p {
  font-size: 15px;
  font-family: Font_Light;
}
.intro_box dl dd h3 {
  margin-top: 0;
  font-size: 18px;
  font-family: Font_Medium;
  overflow: hidden;
}
.intro_box dl dd span {
  display: inline-block;
  width: 400px;
  text-align: center;
  height: 54px;
  line-height: 50px;
  margin-right: 130px;
  color: #2e2e2e;
}
.intro_box dl dd i {
  letter-spacing: 1px;
  font-style: normal;
  font-size: 13px;
  font-family: Font_Medium;
}
.intro_box dl dd em {
  width: 32px;
  height: 30px;
  display: block;
  float: left;
  /* background: url(../images/addr.png) no-repeat 0px 0px; */
}
.intro_box dl dd a {
  float: right;
  color: #2e2e2e;
  font-size: 12px;
  font-family: Font_Medium;
  margin-top: 20px;
  padding-right: 15px;
  /* background: url(../images/more_jt.png) no-repeat right center; */
}
.intro_box dl dd a.a_link {
  float: inherit;
  font-family: Font_Medium;
  margin-top: 0;
  background: none;
}
/*------------about_intro.html  end----------------*/
</style>


// WEBPACK FOOTER //
// src/view/plus/AHOCTIME.vue